import { render, staticRenderFns } from "./CustodianDropdownField.vue?vue&type=template&id=2362b69e"
import script from "./CustodianDropdownField.vue?vue&type=script&lang=ts"
export * from "./CustodianDropdownField.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/PortfolioWeb/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2362b69e')) {
      api.createRecord('2362b69e', component.options)
    } else {
      api.reload('2362b69e', component.options)
    }
    module.hot.accept("./CustodianDropdownField.vue?vue&type=template&id=2362b69e", function () {
      api.rerender('2362b69e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "ClientScripts/Components/Dropdowns/CustodianDropdownField.vue"
export default component.exports